module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_1.39b2f8c4.png";